<div class="grid-x">
  <div class="cell">
    Select Stored Query:
  </div>
  @if (!(loadingQueries$ | async)) {
    <ng-container class="cell">
      <select id="queryOptions" [(ngModel)]="selectedQueryId" (ngModelChange)="selectedQueryChanged($event)">
        @for (query of queries; track query) {
          <option [value]="query.id" [selected]="query.id === selectedQueryId">{{query.name}}</option>
        }
      </select>
    </ng-container>
  } @else {
    <div class="input-line-height margin-bottom">Loading Available Queries...</div>
  }
</div>
@if (componentData.config.query.parameters && componentData.config.query.parameters.length > 0) {
  <div class="grid-x">
    <h2 class="h3 bold">Query Arguments</h2>
  </div>
}
@switch (componentData.config.query.database) {
  @case ('context') {
    <div class="cell small-8">
      Context Value Path
      <input type="text" [(ngModel)]="componentData.config.query.parameters[0].value" />
    </div>
  }
  @default {
    @for (param of componentData.config.query.parameters; track param) {
      <div class="grid-x grid-margin-x outline-container">
        <div class="cell small-12 minor-margin-bottom bold">
          '{{param.name}}' - use value from:
        </div>
        <div class="cell small-3">
          <label class="small-font-size">
            <input [id]="param.name" [name]="param.name" type="radio" class="no-margin" [(ngModel)]="param.source" (ngModelChange)="sourceChanged(param)" value="loggedInUser" />
            Current User
          </label>
        </div>
        <div class="cell small-6">
          <label class="small-font-size text-center">
            <input [id]="param.name" [name]="param.name" type="radio" class="no-margin" [(ngModel)]="param.source" (ngModelChange)="sourceChanged(param)" value="loggedInOrganization" />
            Current Organization
          </label>
        </div>
        <div class="cell small-3">
          <label class="small-font-size text-right">
            <input [id]="param.name" [name]="param.name" type="radio" class="no-margin" [(ngModel)]="param.source" (ngModelChange)="sourceChanged(param)" value="currentDate" />
            Current Date
          </label>
        </div>
        <div class="cell small-4">
          <label class="small-font-size input-line-height">
            <input [id]="param.name" [name]="param.name" type="radio" class="no-margin" [(ngModel)]="param.source" (ngModelChange)="sourceChanged(param)" value="input" />
            Other input value:
          </label>
        </div>
        <div class="cell small-8">
          <input type="text" [(ngModel)]="param.value" [disabled]="param.source !== 'input'" />
        </div>
      </div>
    }
  }
}
<p class="query-note small-font-size">
  {{parameterNote}}
</p>
@if (componentData.config.query.id !== '-1') {
  <div>
    <h2 class="h3 bold">Query Results</h2>
    @if (queryResultsChanged) {
      <div class="grid-x">
        <div class="cell bold red">
          Entity attributes returned by the query have changed since button was last configured!
        </div>
      </div>
    }
    @for (result of componentData.config.query.resultValues; track result) {
      <div class="grid-x">
        <div class="cell">
          {{result.returnValue}} as {{result.returnType}}, Display Name:{{result.returnValueName}}
        </div>
      </div>
    }
    <p class="query-note small-font-size">
      {{resultNote}}
    </p>
    <p class="query-note small-font-size">
      {{resultNote2}}
    </p>
    <p class="query-note small-font-size">
      {{resultNote3}}
    </p>
    <label>
      <span class="label-text bold">Context Target to store HTML representation of results:</span>
      <input type="text" id="htmlResultsContextTarget" placeholder="$..." [(ngModel)]="componentData.config.htmlResultsContextTarget">
    </label>
  </div>
}

